import { Image, VideoCamera, FileText, ArrowSquareOut, ArrowBendUpLeft, Storefront, FlowArrow, Check } from "@phosphor-icons/react";

function renderText(text) {
  if (!text) return null;
  const parts = text.split(/(\{\{\d+\}\})/g);
  return parts.map((p, i) =>
    /^\{\{\d+\}\}$/.test(p) ? (
      <span key={i} className="bg-[#FFDA1A]/40 text-[#111111] rounded-[3px] px-1 font-medium">{p}</span>
    ) : (
      <span key={i}>{p}</span>
    )
  );
}

const MediaHeader = ({ format }) => {
  const map = { IMAGE: Image, VIDEO: VideoCamera, DOCUMENT: FileText };
  const Icon = map[format] || Image;
  return (
    <div className="rounded-[4px] bg-[#E2E7EF] h-32 flex items-center justify-center mb-1.5">
      <Icon className="w-8 h-8 text-[#767676]" weight="regular" />
    </div>
  );
};

const BtnIcon = ({ type }) => {
  const map = { url: ArrowSquareOut, quick_reply: ArrowBendUpLeft, catalog: Storefront, flow: FlowArrow };
  const Icon = map[type] || ArrowBendUpLeft;
  return <Icon className="w-3.5 h-3.5" weight="regular" />;
};

export default function TemplatePreview({ components }) {
  const header = components.find((c) => c.type === "HEADER");
  const body = components.find((c) => c.type === "BODY");
  const footer = components.find((c) => c.type === "FOOTER");
  const buttons = components.find((c) => c.type === "BUTTONS")?.buttons || [];

  return (
    <div className="chat-bg rounded-lg p-4 h-full min-h-[360px] flex flex-col">
      <div className="flex justify-start">
        <div className="max-w-[85%] bg-white rounded-lg rounded-tl-none overflow-hidden">
          <div className="p-2 pb-1.5">
            {header && header.format !== "TEXT" && <MediaHeader format={header.format} />}
            {header && header.format === "TEXT" && header.text && (
              <p className="font-semibold text-[#111111] text-sm mb-1 break-words">{renderText(header.text)}</p>
            )}
            <p className="text-sm text-[#111111] whitespace-pre-wrap break-words leading-snug">
              {body?.text ? renderText(body.text) : <span className="text-[#767676] italic">Isi body template…</span>}
            </p>
            {footer?.text && <p className="text-xs text-[#767676] mt-1.5 break-words">{renderText(footer.text)}</p>}
            <div className="flex justify-end mt-1"><span className="text-[10px] text-[#767676]">10:24 <Check className="w-3 h-3 inline text-[#003399]" weight="bold" /></span></div>
          </div>
          {buttons.length > 0 && (
            <div className="border-t border-[#F0F0F0]">
              {buttons.map((b, i) => (
                <div key={i} className="flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-[#003399] border-b border-[#F0F0F0] last:border-b-0">
                  <BtnIcon type={b.type} /> {b.text || "Tombol"}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
